import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useContext } from 'react';
import { FormStructure as fs } from "../../consts/formStructure";
import {
    updateOverallData
} from '../../helpers/FormHelper';
import { OverallDataContext, TabContext } from '../../pages/CalculatorPage';
import FormInputField from '../inputs/FormInputField';
import FormSubsection from '../inputs/FormSubsection';

export default function TabContent({ category, sect, sectionPageMap={}, pageNum=null, children }) {
    const [inputData, setInputData] = useContext(OverallDataContext).inputData;
    const setTabValue = useContext(TabContext).tabValue[1];
    const inputReadOnly = useContext(OverallDataContext).inputReadOnly[0];

    const tabSectionNames = fs[category]?.sections.filter(ts => ts?.icon);

    const updateData = (fieldData) => {
        updateOverallData(fieldData, setInputData, category);
    }

    const handleTabChange = (key) =>{
        setTabValue( sectionPageMap[key] );
    }
    
    return (
        <>
        { children ?
            <Grid2 container className='mcc-tabcontent' >
                {children}
            </Grid2>
        : ( fs[category] && 
            <Grid2 container className='mcc-tabcontent' >
                <Grid2 xs={12} sm={6}>
                    <Box className='centered-container mcc-tabinfo'> 
                        <Stack spacing={3} sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }} >
                            { pageNum!==null &&
                            <Typography variant='caption' >
                                { pageNum }
                            </ Typography>
                            }

                            <Typography variant='h4' sx={{ fontWeight: '500 !important' }} color={"var(--mcc-contrast1)"}>
                                { fs[category].tabTitle }
                            </Typography>

                            <Stack direction="row" spacing={{ xs: 4, sm: 6 }} >
                            {
                                tabSectionNames.map((ts, key) => {
                                    return (
                                        <Box
                                            key={key}
                                            onClick={() => handleTabChange(key)}
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                overflow: 'visible',
                                                textAlign: 'center',
                                                color: ts?.title === sect?.title ? 'var(--mcc-contrast1)' : 'var(--mcc-contrast2)',
                                                width: '40px',
                                                '&:hover' : {
                                                    color: 'var(--mcc-contrast1)',
                                                    cursor: 'pointer',
                                                }
                                            }}
                                        >
                                        <Box className="large-icon" sx={{ mb: 0.5 }}>
                                            {ts?.icon}
                                        </Box>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                            whiteSpace: 'nowrap', // prevents line break
                                            textAlign: 'center',
                                            }}
                                        >
                                            {ts?.title}
                                        </Typography>
                                        </Box>

                                    )
                                })
                            }
                            </Stack>
                            
                            { sect?.reasoning &&
                            <>
                                <br/>
                                <Typography variant='body2' sx={{ fontWeight: 100 }}>{ sect?.reasoning }</ Typography>
                            </>
                            }
                        </Stack>
                    </Box>
                </Grid2>
                <Grid2 xs={12} sm={6} className='mcc-tabdata sleek-scrollbar' sx={{ display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
                    <Box className='vertically-centered ' sx={{ width: '100%', flexGrow: 1, py: 2 }} >
                    <Stack spacing={5}>
                    { sect.subsections.map((sub, sub_index) => {
                        const filteredFields = sub.fields.filter((field) => {
                            if (!field.dependentOn) return true;
                            const [depField, depValue] = field.dependentOn.split(":");
                            return inputData?.[category]?.[depField] === depValue;
                          });
                          
                        if (filteredFields.length === 0) return null;

                        return (
                        <Box key={sub_index}>
                            <FormSubsection title={sub.title}>
                                {
                                    filteredFields.map((field, f_index) => {
                                        return (
                                            <FormInputField
                                                field={field}
                                                category={category}
                                                key={f_index}
                                                onChangeHandler={updateData}
                                            />
                                        );
                                    })
                                }
                            </FormSubsection>
                        </Box>
                        );
                    })}
                    </Stack>
                    </Box>
                    
                    <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="caption" color="text.secondary">
                        { inputReadOnly ?
                            <>Fields are currently read-only. Click <strong>Edit Inputs</strong> to make changes and recalculate.</>
                        : <>&nbsp;</>
                        }
                        </Typography>
                    </Box>
                </Grid2>

            </Grid2>
        )}
        </>
    );
  }